import { useTranslation } from 'react-i18next';
import NotificationBlock from '@/containers/NotificationBlock';
import { useVeriffStatus } from '@/hooks/shared/useVeriffStatus';
import { NOTIFICATIONS as NOTIFICATIONS_T } from '@/components/Notification/list';

export const MessageHandler = () => {
  const { t } = useTranslation();
  const NOTIFICATIONS = NOTIFICATIONS_T(t);

  const { ready, isVeriffApplyRequired, isVeriffSubmitted } = useVeriffStatus();

  if (ready && isVeriffSubmitted) {
    return (
      <NotificationBlock
        notifications={[
          NOTIFICATIONS.checking_transactions_available_to_verified_users(),
        ]}
      />
    );
  }

  if (isVeriffApplyRequired) {
    return (
      <NotificationBlock
        notifications={[NOTIFICATIONS.provide_your_details_for_transactions()]}
      />
    );
  }

  return null;
};
